var map = {
	"./allyio.jpg": "z8ZQ",
	"./allyio.png": "nV7f",
	"./auzmor-learn.png": "10bF",
	"./freshflows.jpeg": "Q8/f",
	"./nuemorphism.jpg": "p65q",
	"./poornaclinic.png": "rb5m",
	"./tachylogo.png": "aSOb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "N2Zo";